import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, forEach, filter, cloneDeep } from "lodash";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Events from "../Events/Events";
import { fetchPost } from "../../api/fetch";
import { findEvent } from "../../utils/eventGroups";
import { fetchCreatedByUsers } from "../../utils/event";
import { eventGroups, allEvents } from "../../constants/common";
import { eventGroupsData } from "../../constants/eventGroups";
import colors from "../../assets/style/colors";

const styles = {
  container: {
    maxWidth: "calc(100vw - 113px)",
    padding: "24px",
    margin: "12px",
    backgroundColor: colors.white,
    boxShadow: "0px 2px 2px 0px " + colors.black23,
    borderRadius: "2px",
  },
  radio: {
    color: colors.black54,
    fontSize: "1em !important",
    marginRight: "40px !important",
  },
  radioRoot: {
    padding: "0px",
    marginRight: "10px",
  },
};

const ProfileEvents = (props) => {
  const { classes, profileId, language } = props;
  const [events, setEvents] = React.useState();
  const [isFetching, setIsFetching] = React.useState(false);
  const [isFetchingChild, setIsFetchingChild] = React.useState(false);
  const [selectedEvent, setSelectedEvent] = React.useState();
  const [selectedEventId, setSelectedEventId] = React.useState();
  const [section, setSection] = React.useState(eventGroups);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (selectedEventId !== get(selectedEvent, ["id"])) {
      if (!selectedEventId) {
        setSelectedEvent();
      } else if (section === eventGroups) {
        setSelectedEvent(findEvent(get(events, ["items"]), selectedEventId));
      } else if (section === allEvents) {
        forEach(get(events, ["items"]), (e) => {
          if (get(e, ["id"]) === selectedEventId) {
            setSelectedEvent(e);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const loadData = (limit, offset) => {
    if (section === eventGroups) {
      fetchEvents(limit, offset * limit, null, [null]);
    } else if (section === allEvents) {
      fetchEvents(limit, offset * limit, null, [null]);
    }
  };

  const fetchEvents = async (limit = 10, offset = 0, ids, parentIds) => {
    try {
      if (get(parentIds, [0])) {
        setIsFetchingChild(get(parentIds, [0]));
      } else {
        setIsFetching(true);
      }
      let res;
      if (section === eventGroups) {
        let body = {
          pagination: {
            limit,
            offset,
          },
          filter: {
            profile_id: profileId,
          },
          data: eventGroupsData,
        };

        // Filters
        if (ids || parentIds) {
          if (ids) body.filter.ids = ids;
          if (parentIds) body.filter.parent_ids = parentIds;
        }

        res = await fetchPost("new/event_groups", body);
      } else if (section === allEvents) {
        res = await fetchPost("new/events", {
          pagination: {
            limit,
            offset,
          },
          filter: {
            profile_id: profileId,
          },
          data: [
            "id",
            "parent_event_id",
            "active",
            "created_on",
            "created_by",
            "type",
            "profile",
            "zone",
            "event_count",
            "attributes",
            "notes",
            "images",
            "luke_index",
            "device",
            "group",
            "event_version",
          ],
        });
      }
      if (get(parentIds, [0])) {
        let newEvents = cloneDeep(events);
        let children = await fetchCreatedByUsers(get(res, ["items"]));
        forEach(get(newEvents, ["items"]), (e) => {
          if (get(e, ["id"]) === get(parentIds, [0])) {
            e.childEventGroups = children;
          }
        });
        setEvents(newEvents);
      } else {
        res.items = await fetchCreatedByUsers(get(res, ["items"]));
        setEvents(res);
      }
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
    setIsFetchingChild(false);
  };

  const selectEvent = (e) => {
    setSelectedEventId(get(e, ["id"]));
  };

  const closeDetailsPanel = () => {
    setSelectedEvent();
    setSelectedEventId();
  };

  const loadChildEventGroups = (parentId) => {
    fetchEvents(10, 0, null, [parentId]);
  };

  const goToEventGroup = (id) => {
    let eventGroup = get(
      filter(get(events), (item) => get(item, ["id"]) === id),
      [0]
    );
    if (eventGroup) {
      setSelectedEvent(eventGroup);
      setSelectedEventId(id);
    } else {
      console.log("event group not found");
    }
  };

  return (
    <Grid container direction="column" className={classes.container}>
      <Grid item style={{ marginBottom: "24px", paddingLeft: "7px" }}>
        <RadioGroup
          row
          name="section"
          value={section}
          onChange={(e, v) => {
            setSelectedEventId();
            setSelectedEvent();
            setEvents();
            setSection(v);
          }}
        >
          <FormControlLabel
            value={eventGroups}
            control={
              <Radio color="primary" classes={{ root: classes.radioRoot }} />
            }
            label={I18n.get("events_eventGroups")}
            classes={{
              label: classes.radio,
            }}
          />
          <FormControlLabel
            value={allEvents}
            control={
              <Radio color="primary" classes={{ root: classes.radioRoot }} />
            }
            label={I18n.get("events_allEvents")}
            classes={{
              label: classes.radio,
            }}
          />
        </RadioGroup>
      </Grid>
      <Grid item style={{ maxWidth: "calc(100%)" }}>
        <Events
          events={get(events, ["items"])}
          total={get(events, ["total"])}
          isFetching={isFetching}
          isFetchingChild={isFetchingChild}
          dialog={false}
          loadData={loadData}
          selectEvent={selectEvent}
          selectedEvent={selectedEvent}
          loadChildEventGroups={loadChildEventGroups}
          closeDetailsPanel={closeDetailsPanel}
          goToEventGroup={goToEventGroup}
          section={section}
          selectedEventId={selectedEventId}
          language={language}
          myprofile={profileId}
          displayOptions={{
            hideSectionBar: true,
            noPadding: true,
            noShadow: true,
            tableHeight: "calc(100vh - 347px)",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(ProfileEvents);
